<template lang="pug">
  .container
    notifications(group="request" position="top center")
    ReloadAppDialog(:showDialog="showDialog")
    b-form.form-horizontal(@submit.prevent="create")
      b-row
        b-col
          b-form-group(label="ID Zendesk (separar con comas)")
            icon.loader-in-field(name="refresh" v-if="loader" spin)
            input-tag(:on-change="fetchData" ,:tags="complaint.zendesk" ,:validate="'digits'" required)

          b-form-group(label="Categoría")
            selectize(v-model="complaint.category" name="complaint[category]" placeholder="Elige una categoría" required)
              option(v-for="key in Object.keys(categories).splice(0, Object.keys(categories).length - 1)" ,:value="key" ,:key="key") {{ categories[key].description }}

          b-form-group(label="Exigencia")
            b-form-input.form-control(v-model.trim="complaint.comment" name="complaint[comment]"
            type="text" v-bind:placeholder="description_placeholder" required)

          b-form-group(label="Reclamante")
            b-form-input.form-control(v-model.trim="complaint.issuer_name" name="complaint[issuer]"
            type="text" v-bind:placeholder="name_placeholder" required)

          b-form-group(label="Género del reclamante")
            b-form-radio-group(v-model="complaint.issuer_gender" ,:options="[{ text: 'Hombre', value: 'male' }, { text: 'Mujer', value: 'female' }]" name="genderSelector")

          b-form-group(label="Texto Original" v-if="complaint.description")
            b-form-textarea.form-control(v-model.trim="complaint.description" ,:rows="6"
            name="complaint[description]" placeholder="Texto Original del Cliente" tabindex="-1" readonly)

          b-form-group(label="Primer contacto" v-if="complaint.first_contact")
            b-form-input.form-control(v-model="complaint.first_contact" name="complaint[first_contact]"
            type="text" tabindex="-1" readonly)

          b-form-group(v-if="complaint.last_contact" label="Último Contacto")
            b-form-input.form-control(v-model="complaint.last_contact" name="complaint[last_contact]"
            type="text" tabindex="-1" readonly)

        b-col
          b-form-group(label="Número de Compra")
            b-input-group
              b-form-input(v-model="complaint.ticket_info.booking_number" @input="onSearchChange")
              b-input-group-button(slot="right")
                .get-tickets-response(:class="ticketResponseClass")
                  icon(name="refresh" v-if="getTicketsLoader" spin)
                  icon(name="times" v-if="getTicketsError")
                b-btn(variant="primary" ,@click="getTickets()") Buscar

          b-form-group(label="Pasajes", v-if="booking_tickets.length > 0")
            selectize(multiple :select-size="4" ,:plain="true" v-model="selected" placeholder="Elige un pasaje" required)
              option(v-for="t in booking_tickets" ,:key="t.id" ,:value="t.number") {{`${t.number} ${t.departure} - ${t.destination} (${t.inbound ? 'Vuelta' : 'Ida' })`}}
            small
              strong Selecciona los pasajes afectados.
          b-form-group(v-if="complaint.source === 'voice' && complaint.category === '3'", label="Correo cliente")
            b-form-input.form-control(v-model="complaint.ticket_info.email" class="form-control"
            name="complaint[ticket_info][email]" type="text")

          b-form-group(label="Nombre del pasajero" v-if="booking_tickets.length > 0")
           b-form-input(disabled :value="complaint.ticket_info.fullname")

          b-form-group(v-if="complaint.ticket_info.bus_operators.length > 0" label="Empresas")
            b-form-input.form-control(:value="formatOperator(complaint.ticket_info.bus_operators)" name="complaint[ticket_info][bus_operators]"
            type="text" readonly)

          b-form-group(v-if="complaint.ticket_info.origin" label="Origen")
            b-form-input.form-control(v-model="complaint.ticket_info.origin" class="form-control"
            name="complaint[ticket_info][origin]" type="text" readonly)

          b-form-group(v-if="complaint.ticket_info.destination" label="Destino")
            b-form-input.form-control(v-model="complaint.ticket_info.destination" class="form-control"
            name="complaint[ticket_info][destination]" type="text" readonly)

          b-form-group(v-if="complaint.ticket_info.departure_date" label="Fecha de salida (Ida)")
            b-form-input.form-control(v-model="complaint.ticket_info.departure_date" class="form-control"
            name="complaint[ticket_info][departure_date]" type="text" readonly)

          b-form-group(v-if="complaint.ticket_info.departure_hour" label="Hora de salida (Ida)")
            b-form-input.form-control(v-model="complaint.ticket_info.departure_hour"
            name="complaint[ticket_info][departure_hour]" type="text" readonly)

          b-form-group(v-if="complaint.ticket_info.arrival_date" label="Fecha de salida (Vuelta)")
            b-form-input(v-model="complaint.ticket_info.arrival_date" class="form-control"
            name="complaint[ticket_info][arrival_date]" type="text" readonly)

          b-form-group(v-if="complaint.ticket_info.arrival_hour" label="Hora de salida (Vuelta)")
            b-form-input.form-control(v-model="complaint.ticket_info.arrival_hour" name="complaint[ticket_info][arrival_hour]"
            type="text" readonly)

          b-form-group(v-if="complaint.ticket_info.payment_method" label="Método de Pago")
            b-form-input.form-control(v-model="complaint.ticket_info.payment_method"  name="complaint[ticket_info][payment_method]"
            type="text" readonly)

          b-form-group(v-if="complaint.ticket_info.price" label="Monto Total")
            b-form-input.form-control(v-model="complaint.ticket_info.price" name="complaint[ticket_info][price]"
            type="text" readonly)

          b-form-group(v-if="complaint.ticket_info.price_ibc" label="Monto Total IBC")
            b-form-input.form-control(v-model="complaint.ticket_info.price_ibc" name="complaint[ticket_info][price_ibc]"
            type="text" readonly )

      b-form-group.text-center
        b-button.positive-action.btn-lg(type="submit" variant="primary") Abrir reclamo

</template>

<script>
/* eslint-disable no-console */
import Selectize from 'vue2-selectize';
import InputTag from 'vue-input-tag';
import jwtDecode from 'jwt-decode';
import router from '@/router';
import kexaApi from '@/services/apiService';
import integration from '@/constants/Integration.constants';
import constants from '@/constants/Status.constants';
import dateService from '@/utils/dateService';

export default {
  name: 'new',
  components: {
    Selectize,
    InputTag,
  },
  computed: {
    ticketResponseClass() {
      let theClass;

      if (this.getTicketsError) {
        theClass = 'has-error';
      }
      return theClass;
    },
  },
  data() {
    return {
      loader: false,
      getTicketsLoader: false,
      getTicketsError: false,
      complaint: {
        zendesk: [],
        status: 0,
        issuer_gender: 'male',
        ticket_info: {
          tickets: [],
          bus_operators: [],
        },
        internal_source: {
          origin: '',
          responsible: '',
        },
      },
      booking_tickets: [],
      selected: [],
      statuses: constants.STATUSES,
      categories: [],
      first_ticket: null,
      description_placeholder: 'Ej: Devolución en cupón, camión nunca llegó',
      name_placeholder: 'Ej: Ernesto Alcazar',
      intervalId: null,
      showDialog: false,
    };
  },
  mounted() {
    this.fetchCategories();
    if (Object.prototype.hasOwnProperty.call(this.$route.query, 'zendesk')) {
      this.$set(this.complaint, 'zendesk', [this.$route.query.zendesk]);
      this.fetchData();
    }
    if (Object.prototype.hasOwnProperty.call(this.$route.query, 'booking')) {
      this.$set(this.complaint.ticket_info, 'booking_number', this.$route.query.booking);
      this.getTickets();
    }
    if (Object.prototype.hasOwnProperty.call(this.$route.query, 'category')) {
      this.$set(this.complaint, 'category', this.$route.query.category);
    }
    if (this.complaint.ticket_info.booking_number === undefined && this.complaint.zendesk.length === 0
          && this.complaint.category === undefined && Object.keys(this.$route.query).length !== 0) {
      this.getBehatzaileData();
    }
    this.refreshReloaAppStatus();
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  watch: {
    selected() {
      if (this.selected.length === 0) {
        const booking = this.complaint.ticket_info.booking_number;
        this.complaint.ticket_info = {
          booking_number: booking,
          tickets: [],
          bus_operators: [],
        };
      } else {
        const info = this.complaint.ticket_info;
        info.tickets = this.selected;
        const filtered = this.booking_tickets.filter(ticket =>
          this.selected.includes(ticket.number));
        const dep = filtered[0];
        const arr = filtered[filtered.length - 1];
        info.departure_date = dep.departure_date;
        info.departure_hour = dep.departure_hour;
        info.origin = dep.departure;
        info.destination = dep.destination;
        info.departure = dep.departs_at;
        if (filtered.length > 1 && dep.inbound !== arr.inbound && arr.inbound) {
          info.arrival_date = arr.departure_date;
          info.arrival_hour = arr.departure_hour;
          info.arrival = arr.departs_at;
        } else {
          info.arrival_date = null;
          info.arrival_hour = null;
          info.arrival = null;
        }
        info.price = filtered.reduce((total, ticket) => total + parseInt(ticket.price, 10), 0);
        info.price_ibc = filtered.reduce((total, ticket) =>
          total + parseInt(ticket.price_ibc, 10), 0);
        info.price_usd = filtered.reduce((total, ticket) =>
          total + parseFloat(ticket.price_usd, 10), 0);
        info.original_price = filtered.reduce((total, ticket) =>
          total + parseInt(ticket.original_price, 10), 0);
        info.payment_method = filtered[0].payment_method;
        info.paypal_transaction = filtered[0].paypal_transaction;
        info.sold_currency = filtered[0].sold_currency;
        info.operator_currency = filtered[0].operator_currency;
        info.sales_company = filtered[0].sales_company;
        info.is_whitelabel = filtered[0].is_whitelabel;
        info.ticket_ids = filtered.map(ticket => ticket.id);
        if (filtered[0].email !== 'accounting@recorrido.cl') {
          info.email = filtered[0].email;
        }
        info.fullname = filtered[0].fullname;
        info.bus_operators = filtered.map((ticket) => {
          if (ticket.id === dep.id) {
            return dep.bus_operator;
          } else if (ticket.id === arr.id) {
            return arr.bus_operator;
          }
          return ticket.bus_operator;
        }).filter((val, i, self) => self.indexOf(val) === i);
        info.discount_coupons = filtered[0].discount_coupons;
      }
    },
  },
  methods: {
    create() {
      kexaApi.post(this.complaint).then(() => {
        router.push('/complaints');
      }).catch((res) => {
        this.$notify({
          group: 'request',
          type: 'error',
          title: 'Error',
          text: res.body.join('<br>'),
          duration: 3000,
          dangerouslyUseHTMLString: true,
        });
      });
    },
    fetchCategories() {
      kexaApi.get_categories().then((res) => {
        this.categories = res.body.reduce((acc, item) => {
          acc[item.number] = { description: item.name };
          return acc;
        }, {});
      });
    },
    fetchData() {
      const ticket = this.complaint.zendesk[0];
      if (ticket === undefined) {
        this.$set(this.complaint, 'first_contact', null);
        this.$set(this.complaint, 'last_contact', null);
        this.$set(this.complaint, 'issuer_contact', null);
        this.$set(this.complaint, 'issuer_name', null);
        this.$set(this.complaint, 'source', null);
        this.$set(this.complaint, 'description', null);
        this.first_ticket = null;
      } else if (this.first_ticket !== ticket) {
        this.loader = true;
        kexaApi.zendeskInfo(this.complaint.zendesk[0]).then((res) => {
          this.loader = false;
          const t = res.body.ticket;
          const created = dateService.getDate(t.created_at);
          const updated = dateService.getDate(t.updated_at);
          this.$set(this.complaint, 'first_contact', created);
          this.$set(this.complaint, 'last_contact', updated);
          this.$set(this.complaint, 'issuer_contact', this.getIssuerData(t.via) || '-');
          this.$set(this.complaint, 'issuer_name', t.via.source.from.name || '-');
          this.$set(this.complaint, 'source', t.via.channel);
          this.$set(this.complaint, 'description', t.description);
          this.first_ticket = this.complaint.zendesk[0];
        }).catch(() => {
          this.$notify({
            group: 'request',
            type: 'error',
            title: 'Error',
            text: 'Ocurrió un error con ese ticket de Zendesk.',
            duration: 3000,
          });
        });
      }
    },
    getTickets() {
      this.getTicketsLoader = true;
      this.getTicketsError = false;
      kexaApi.ticketInfo(this.complaint.ticket_info.booking_number, this.complaint.category).then((res) => {
        console.log('Response from KexaApi');
        console.log(res);
        this.getTicketsLoader = false;
        this.$set(this, 'booking_tickets', res.body.data);

        if (res.body.data.length !== 0) {
          this.$set(this.complaint.ticket_info, 'booking_number', res.body.data[0].token);
        }
        const invalidTickets = res.body.invalid_tickets;

        if (invalidTickets.length > 0) {
          this.$notify({
            group: 'request',
            type: 'warning',
            title: 'Advertencia',
            text: `No se consideraron los tickets con número: ${invalidTickets}, debido a alguna de estas razones:` +
            '<br>- Tiene categoría Transbank error y más de 90 días a partir de la fecha de salida' +
            '<br>- Tiene categoría Reclamo cupón y más de los 6 meses del periodo de validez' +
            '<br>- Tienen otra categoría y más de 30 días a partir de la fecha de salida',
            duration: 8000,
          });
        }
      }).catch((e) => {
        console.log('An error was found');
        console.log(e);
        this.getTicketsError = true;
        this.$notify({
          group: 'request',
          type: 'error',
          title: 'Error',
          text: 'Número de compra no encontrado',
          duration: 3000,
        });
      });
    },
    formatOperator(value) {
      return (value.length === 2) ? `${value[0]} (Ida) ${value[1]} (Vuelta)` : `${value[0]}`;
    },
    getIssuerData(src) {
      if (src.channel === 'email') {
        return src.source.from.address;
      }
      if (src.channel === 'facebook') {
        return src.source.from.profile_url;
      }
      return src.source.from.phone;
    },
    getBehatzaileData() {
      try {
        const data = jwtDecode(Object.keys(this.$route.query)[0]);
        if (data && data.origin === integration.BEHATZAILE_TOKEN) { // TODO: move to vite env in a future vue update
          this.$set(this.complaint.ticket_info, 'booking_number', data.booking);
          this.$set(this.complaint.internal_source, 'origin', 'behatzaile');
          this.$set(this.complaint.internal_source, 'responsible', data.user);
          this.getTickets();
        } else {
          throw new Error();
        }
      } catch (e) {
        this.$notify({
          group: 'request',
          type: 'error',
          title: 'Error',
          text: 'El ingreso de reclamo no coincide. <br/> Genere el reclamo desde un link válido.',
          duration: 5000,
        });
        setTimeout(() => router.push({ name: 'complaints' }), 5000);
      }
    },
    onSearchChange() {
      this.booking_tickets = [];
      this.selected = [];
      this.complaint.ticket_info = {
        booking_number: this.complaint.ticket_info.booking_number,
        tickets: [],
        bus_operators: [],
      };
    },
    refreshReloaAppStatus() {
      this.intervalId = setInterval(() => {
        kexaApi.reloadAppStatus().then((response) => {
          if (response.body) {
            this.showDialog = true;
          }
        });
      }, 900000);
    },
  },
};
</script>

<style lang="scss">
  @import '../../assets/css/kexa-variables';

  .form-horizontal .form-group {
    @media screen and (min-width: 768px) {
      min-width: 456px;
    }
  }
  .form-row {
    .vue-input-tag-wrapper {
      .new-tag,
      .input-tag {
        font: {
          size: 1rem;
        }
        color: #000;
      }
      .input-tag {
        background: {
          color: $light-green;
        }
      }
    }
  }
  .loader-in-field.fa-icon {
    color: $icon-color;
    position: absolute;
    top: 40px;
    right: 26px;
  }
  .get-tickets-response {
    position: absolute;
    right: 84px;
    top: 8px;
    z-index: 3;
    color: #007bff;
    &.has-error {
      color: red;
    }
  }
  .b-form-group {
    .vue-input-tag-wrapper {
      .input-tag {
        background: {
          color: $light-green;
        }
        color: #000;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/complaints/New.vue